module.exports = __webpack_public_path__ + "img/liangyou.2ef4f0da.png";